import getGroupsApi from './getGroupsApi';

export default {
  getGroupsApi,
};
